import { DateRangeRepository } from '../date-range';
import { AppletHost, FormattedDateTime, MOMENT_FORMAT_STRING } from './external';

export async function installAppletHost() {
  const dateRangeRepository = await DateRangeRepository.getInstance();
  let inMemoryNamespaces = [];
  for(let x=0; x < 100; x++){
    inMemoryNamespaces[`contentstream_${x}`] = [];
  }

  const getNamespaces = () => {
    const namespaces = {}
    for(let x=0; x < 100; x++){
      namespaces[`contentstream_${x}`] = {}
    }
    return namespaces
  }

  AppletHost.install({
    coordinatedQueryTimeProvider: async () => new FormattedDateTime(moment().format(MOMENT_FORMAT_STRING)),
    dateRangeRepository,
    inputsRepository: {
      get: ({ namespace }) => {
        return inMemoryNamespaces[namespace] || [];
      },
      set: (value, namespace) => {
        inMemoryNamespaces[namespace] = value || [];
      },
    },
    namespaces: {
      ...getNamespaces()
    },
  });
}
